<template>
  <div class="content-wrapper questionnare-wrapper questionnare-question-1">
    <div class="d-flex align-items-start justify-content-center full-height">
      <div class="center full-width">
        <div class="small-text uppercase">Question 1 of 4</div>
        <h3 class="my-4 general-title">Who are you?</h3>
        <div class="question-container my-9 d-flex">
          <input class="center" type="text" name="name" placeholder="FIRST NAME *" v-model="inputName" />
          <input class="center" type="text" name="surname" placeholder="LAST NAME *" v-model="inputSurame" />
          <input class="center" type="email" name="email" placeholder="EMAIL ADDRESS *" v-model="inputEmail" />
          <input class="center" type="text" name="birthdate" placeholder="YEAR OF BIRTH *" v-model="inputBirthdate" />
          <select class="center" name="weight" placeholder="WEIGHT (KG)" v-model="inputWeight">
              <option selected disabled>WEIGHT (KG) *</option>
              <option value="50-60">50 - 60 KG</option>
              <option value="60-70">60 - 70 KG</option>
              <option value="70-80">70 - 80 KG</option>
              <option value="80+">MORE THAN 80KG</option>
              <option value="none">I'DE RATHER NOT SAY</option>
          </select>
          <input class="center" type="text" name="liveplace" placeholder="WHERE DO YOU LIVE? *" v-model="inputLiveplace" />
          <button
            class="btn btn-outline-primary questionnaire-next"
            type="button"
            value="Next question"
            v-on:click="localGoNext"
            >
          Next Question
          </button>
        </div>
        <div class="row">
          <label for="">* These are required fields</label>
        </div>
      </div>
      <a v-on:click="$emit('skip-questionnaire')" class="skip-button small-text uppercase" href="#">skip questionnaire</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "question-1",
  data() {
    return {
      'errors': []
    };
  },
  props: ['questionAnswers'],
  methods: {
    localGoNext: function() {
      if (this.canGoNext()) {
        this.$emit('go-next');
      }
    },
    canGoNext: function() {
      let err = false;
      let firstFocus = false;
      let requiredField = ['name', 'surname', 'email', 'birthdate', 'weight', 'liveplace'];

      let firstName = window.localStorage.getItem('customerName');
      if(firstName !== null) {
        this.inputName = firstName;
      }

      let surname = window.localStorage.getItem('customerSurname');
      if (surname !== null) {
        this.inputSurame = surname;
      }

      let email = window.localStorage.getItem('customerEmail');
      if (email !== null) {
        this.inputEmail = email;
      }

      for (let i = 0; i < requiredField.length; i++) {
        let fieldName = requiredField[i];
        let k = this.questionAnswers[fieldName];

        if (typeof k == "undefined" || k == "") {
          if (!firstFocus && document.querySelector("[name=" + fieldName + "]") != null) {
            document.querySelector("[name=" + fieldName + "]").focus();
          }
          err = true;
          firstFocus = true;
        }

        if (fieldName == 'email' && !this.validEmail(this.questionAnswers[fieldName])) {
          err = true;
          firstFocus = true;
        }
      }
      return !err;
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  mounted() {
      document.querySelector('select option:first-child').removeAttribute('selected');
      document.querySelector('select option:first-child').setAttribute('selected', 'selected');
  },
  computed: {
    inputName: {
      get() {
        let firstName = window.localStorage.getItem('customerName');
        if (firstName !== null) {
          return firstName;
        }

        return this.questionAnswers.name;
      },
      set(answer) {
        window.localStorage.setItem('customerName', answer);
        this.$emit('set-answer', answer, 'name');
      }
    },
    inputSurame: {
      get() {
        let surname = window.localStorage.getItem('customerSurname');
        if (surname !== null) {
          return surname;
        }
        return this.questionAnswers.surname;
      },
      set(answer) {
        window.localStorage.setItem('customerSurname', answer);
        this.$emit('set-answer', answer, 'surname');
      }
    },
    inputEmail: {
      get() {
        let email = window.localStorage.getItem('customerEmail');
        if (email !== null) {
          return email;
        }
        return this.questionAnswers.email;
      },
      set(answer) {
        window.localStorage.setItem('customerEmail', answer);
        this.$emit('set-answer', answer, 'email');
      }
    },
    inputBirthdate: {
      get() {
        return this.questionAnswers.birthdate;
      },
      set(answer) {
        this.$emit('set-answer', answer, 'birthdate');
      }
    },
    inputWeight: {
      get() {
        return this.questionAnswers.weight;
      },
      set(answer) {
        this.$emit('set-answer', answer, 'weight');
      }
    },
    inputLiveplace: {
      get() {
        return this.questionAnswers.liveplace;
      },
      set(answer) {
        this.$emit('set-answer', answer, 'liveplace');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.questionnare-question-1 {
  input[type=text],
  input[type=email],
  select {
    width: 33%;
    border: none;
    border-bottom: 1px solid black;
    outline: none;
    margin-right: 15px;
    @media (max-width: 767px) {
      width: 100%;
      height: 50px;
      margin-right: 0;
    }
  }

  input[type=email] {
    width: 33%;
  }
}

.questionnaire-next {
  width: 300px !important;
  padding: 0;
  @media (max-width: 767px) {
    margin-top: 20px !important;
  }
}
</style>